import { render, staticRenderFns } from "./timelineItem.vue?vue&type=template&id=5078846e&"
import script from "./timelineItem.vue?vue&type=script&lang=js&"
export * from "./timelineItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!/Users/administrador/developments/dtouch/dtouch-client/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib'
import { VRow } from 'vuetify/lib'
import { VTimelineItem } from 'vuetify/lib'
installComponents(component, {VCol,VRow,VTimelineItem})
